<!-- Alert -->
<fuse-alert
    class="mt-8 top-0 right-0 absolute z-99"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert>

<!-------------------------------------------------------------->
<!---------------------- Skeleton loader ----------------------->
<!-------------------------------------------------------------->

<div *ngIf="loading">

    <div class=" flex-col w-full justify-center items-center">
        <div class="w-full md:w-1/2">
            <ngx-skeleton-loader
                [theme]="{ 
                    'border-radius': '15px',
                    height: '600px'
                }"
            ></ngx-skeleton-loader>
        </div>
    </div>
</div>

<div *ngIf="!loading">
    <div class="flex flex-col py-4 w-full justify-center items-center">

        <div class="w-full md:w-1/2">

            <div>
                <div class="font-extrabold text-xl">
                    {{corePackage?.PackageName}}
                </div>
                <div class="py-2 text-black text-lg">
                    Download {{corePackage?.MbpsDownload}}Mbps | Upload {{corePackage?.MbpsUpload}}Mbps
                </div>
            </div>
    
            <fuse-card class="flex flex-col shadow-xl p-5 rounded-2xl">
                <div class="flex flex-row w-full justify-between items-center">
                    <div class="font-extrabold text-lg">
                        My cart
                    </div>
                    <div (click)="clearCart()" class="flex flex-row items-center hover:cursor-pointer">
                        <mat-icon svgIcon="heroicons_solid:trash" [color]="'warn'"></mat-icon>
                        <div class="text-red-500 ml-2 font-extrabold">Remove</div>
                    </div>
                </div>
    
                <hr class="my-5">
    
                <div class="flex flex-row w-full justify-between">
                    <img class="h-4 md:h-8 w-auto" [src]="providerLogo" alt="ProviderLogoFile" loading="lazy">
                    <div class="font-bold">
                        {{corePackage?.MbpsDownload}}/{{corePackage?.MbpsUpload}}Mbps 
                        {{corePackage?.PackageName?.includes('Uncapped') ? 'Uncapped' : 'Capped'}}
                        {{serviceType}}
                    </div>
                </div>
    
                <div class="flex flex-col">
                    <div class="text-2xl font-extrabold py-4">
                        Included:
                    </div>
    
                    <div *ngIf="onceOffs" class="flex flex-row w-full pb-2 text-black justify-between">
                        <div>
                            {{onceOffs?.OfferableName}}
                        </div>
                        <div class="font-bold">
                            {{onceOffs?.Billing_TotalIncl | currency:'R'}}
                        </div>
                    </div>
    
                    <div *ngIf="promoTypeArray?.length">
                        <div *ngFor="let pa of promoTypeArray" class="flex flex-row w-full pb-2 text-black justify-between">
                            <div>
                                Promo: {{pa?.name}}
                            </div>
                            <div *ngIf="pa.type == '%'" class="font-bold">
                                {{pa.amount}} {{pa.type}}
                            </div>
                            <div *ngIf="pa.type != '%'" class="font-bold">
                                {{pa.type}} {{pa.amount}}
                            </div>
                        </div>
                    </div>
                </div>
    
                <hr class="my-5">
    
                <!-- PROMO CODE -->
    
                <div class="flex flex-row pb-2 text-black font-extrabold">
                    Apply promo Code
                </div>
                <div class="flex flex-row justify-between">
                    <div class="border-1 border-primary p-2 rounded-lg w-full">
                        <input matInput #promoInput placeholder="Promo code" [(ngModel)]="promoCode">
                    </div>
                    <div>
                        <button mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4" (click)="redeemPromoCode(promoCode)">
                            Redeem
                        </button>
                    </div>
    
                    <hr class="my-5">
                </div>
    
                <!-- FIBRE INSTALLED -->
    
                <!-- add logic to hide accoring to type -->
                <div *ngIf="corePackage?.OfferableSubTypeName == 'Fibre (FTTH)'">
                    <div class="flex flex-row pb-2 text-black font-extrabold">
                        Fibre already installed at this address:
                    </div>
                    <div class="flex flex-col justify-between">
                        <mat-radio-button [checked]="hasFibreInstalled" [color]="'primary'" value="Yes" (change)="addressHasFibre($event)">Yes</mat-radio-button>
                        <mat-radio-button [checked]="!hasFibreInstalled" [color]="'primary'" value="No" (change)="addressHasFibre($event)">No</mat-radio-button>
                    </div>
                </div>
    
                <hr class="my-5">
    
                <div class="flex flex-row w-full justify-between items-center">
                    <div class="flex flex-col">
                        <div class="font-extrabold text-lg py-2">
                            What you pay:
                        </div>
                        <div class="font-extrabold text-primary text-2xl">
                            {{monthlyPrice | currency:'R'}} per month
                        </div>
                        <div class="font-extrabold text-primary text-md">
                            {{onceoffPrice | currency:'R'}} once off
                        </div>
                    </div>
                    <!-- <div class="flex flex-col">
                        <div>
                            <button
                                mat-flat-button
                                [disabled]="disableButton"
                                [class.green]="disableButton"
                                class="bg-accent text-primary rounded-full py-2 px-4 ml-4"
                                (click)="checkout()">
                                    Checkout
                            </button>
                        </div>
                        <div class="flex flex-row items-center py-2">
                            <mat-icon svgIcon="heroicons_outline:lock-closed"></mat-icon>
                            <div class="text-xs text-black">
                                Secure Checkout
                            </div>
                        </div>
                    </div> -->
    
                </div>
    
            </fuse-card>
        </div>
    </div>

</div>